import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { DayMaxThreeComponent } from '../nettleie/dayMaxThree/dayMaxThree.component';
import { Hours, newAnalysisDay } from 'src/app/services/analyse/analyse.types';
import { AnalyseService } from 'src/app/services/analyse/analyse.service';
import { theTime } from 'src/app/utils/date-utils';

@Component({
  selector: 'app-new-month-no-analysis',
  standalone: true,
  imports: [CommonModule, IonicModule, DayMaxThreeComponent],
  template: `<ion-row>
    <ion-col>
      <div class="bg-[--primary-strong-100] p-4 rounded-lg mb-8">
        <p class="text-center mt-0">
          <strong
            >Neste strømanalyse er tilgjengelig {{ newAnalysisDay }}.
            {{ monthLabel }}</strong
          >
        </p>
        <p>
          Vi trenger litt mer datagrunnlag før vi kan lage analysen for
          inneværende måned. I mellomtiden kan du dykke i analysen for forrige
          måned, og se døgnmakser så langt i måneden.
        </p>
        @if (currentHighThreeDayMax) {
        <div class="border border-[--primary-strong] rounded-lg bg-white">
          <app-daymax-three
            [currentHighThreeDayMax]="currentHighThreeDayMax"
          ></app-daymax-three>
        </div>
        } @else {
        <p class="bg-[--warning-40] p-4 rounded-lg m-0">
          Det skjedde dessverre en feil når vi prøvde å hente døgnmakser for
          inneværende måned. Prøv igjen senere.
        </p>
        }
      </div>
    </ion-col>
  </ion-row>`
})
export class NewMonthNoAnalysisComponent {
  @Input() objectId: string;

  currentHighThreeDayMax: Hours[];
  now = new Date();
  monthLabel = this.now.toLocaleDateString('nb-NO', { month: 'long' });
  newAnalysisDay = newAnalysisDay;

  constructor(private _analyseService: AnalyseService) { }

  ngOnChanges() {
    this._analyseService
      .getAnalyzePeriod(
        this.objectId,
        theTime().to(["YYYY", "MM"])
      )
      .subscribe({
        next: (res) => {
          this.currentHighThreeDayMax = res.nettleietrinn.hours_high_three;
        }
      });
  }
}
